import { z } from 'zod'
import { oc } from '@orpc/contract'

const orgSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
})

export const organizationConnectSchema = z.object({
  id: z.string(),
  status: z.enum(['pending', 'accepted', 'declined']),
  initiator: orgSummarySchema,
  recipient: orgSummarySchema.nullable(),
  recipientEmail: z.string().nullable(),
  createdAt: z.string(),
  role: z.enum(['initiated', 'received']),
  acceptUrl: z.string().nullable(),
})

export const listOrganizationConnects = oc
  .route({ method: 'GET', path: '/v2/organizations/connects' })
  .input(z.object({}))
  .output(
    z.object({
      items: z.array(organizationConnectSchema),
    }),
  )
